import Vue from 'vue'
Vue.mixin({
    methods: {
      numberFormat(num) {
        let number = Math.round(num);
        var str = number.toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        return str.join('.');
    },
    removeTagsHtml(value) {
        var div = document.createElement("div");
        div.innerHTML = value;
        var text = div.textContent || div.innerText || "";
        return text
    },
    }
})